import { Component, OnInit } from '@angular/core';
import { RewardsWalletService } from '@fgb/core';
import { HideMobileNav } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-lotto-wallet-details-page',
  templateUrl: './lotto-wallet-details-page.component.html',
  styleUrls: ['./lotto-wallet-details-page.component.scss'],
  hostDirectives: [HideMobileNav],
})
export class LottoWalletDetailsPageComponent implements OnInit {
  constructor(private rewardsWalletService: RewardsWalletService) {}

  ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
